/**
 * CCMS termination codes (`termination.terminateCd`) and Account access policy.
 *
 * In `rules.js`, a rule predicate returning `false` means the user keeps
 * dashboard access despite `termination.status === "Terminated"`.
 */

export const TERMINATE_CODE = {
  /** Acceptable Progress — retain dashboard access (policy may change later). */
  ACCEPTABLE_PROGRESS: "GK",
  /** Unemployment — lose access immediately. */
  UNEMPLOYMENT: "TE",
  /** University (Grad) — 4 months access for students. */
  UNIVERSITY_GRAD: "TG",
  /** Non-Payment of dues — lose access immediately. */
  NON_PAYMENT: "TN",
  /** University (Drop) — lose access immediately. */
  UNIVERSITY_DROP: "TD",
}
